/**
 * src/shared/publicUpload.js
 *
 * Botón de subida de archivos para la página pública /registrar.
 * Sube a /api/upload.php en el mismo servidor.
 */

import { h } from '@core/dom.js'

/** Sube un archivo y devuelve la URL pública */
export async function uploadPublic(file, folder = 'solicitudes') {
    const fd = new FormData()
    fd.append('file', file)
    fd.append('folder', folder)

    const res = await fetch('/api/upload.php', { method: 'POST', body: fd })
    const data = await res.json()
    if (!res.ok || !data.ok) throw new Error(data?.error || `Error ${res.status}`)
    return data.url
}

/**
 * Crea un botón que sube archivo(s) y escribe la URL en el input destino.
 * - input normal → reemplaza el valor
 * - textarea     → agrega cada URL en una línea nueva (galería)
 */
export function publicUploadButton(inputEl, { accept = 'image/*', multiple = false, maxLines = 0 } = {}) {
    const fileInput = h('input', { type: 'file', accept, style: 'display:none' })
    if (multiple) fileInput.multiple = true

    const btn = h('button', {
        className: 'reg-upload-btn', type: 'button', title: 'Subir archivo'
    }, '📤 Subir')

    btn.addEventListener('click', () => fileInput.click())

    fileInput.addEventListener('change', async () => {
        const files = [...fileInput.files]
        if (!files.length) return

        btn.disabled = true
        const original = btn.textContent

        try {
            for (const [i, file] of files.entries()) {
                btn.textContent = files.length > 1 ? `⏳ ${i + 1}/${files.length}` : '⏳…'
                const url = await uploadPublic(file)
                if (inputEl.tagName === 'TEXTAREA') {
                    const lines = inputEl.value.split('\n').map(s => s.trim()).filter(Boolean)
                    if (maxLines && lines.length >= maxLines) {
                        alert(`Solo puedes subir hasta ${maxLines} fotos en este plan.`)
                        break
                    }
                    lines.push(url)
                    inputEl.value = lines.join('\n')
                } else {
                    inputEl.value = url
                }
                inputEl.dispatchEvent(new Event('input', { bubbles: true }))
            }
        } catch (err) {
            alert(`No se pudo subir el archivo: ${err.message}`)
        } finally {
            btn.disabled = false
            btn.textContent = original
            fileInput.value = ''
        }
    })

    return h('div', { className: 'reg-upload' },
        h('div', { style: 'flex:1' }, inputEl),
        btn,
        fileInput
    )
}
